import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../api/rootApi";

const Review = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const redirect_uri = "/";
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    fetch(`${BASE_URL}/reviews`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        alert("Review Added Successfully!");
        reset();
        navigate(redirect_uri);
      });
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex flex-col bg-slate-50/50">
      <main className="flex-grow py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 mb-3">
              Share Your Experience
            </h2>
            <p className="text-lg text-slate-600 max-w-xl mx-auto">
              Your feedback is incredibly valuable to us and our community. Let us know how we did!
            </p>
          </div>

          {/* Form Card */}
          <div className="bg-white py-10 px-8 shadow-sm rounded-2xl border border-slate-200/60">
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-7">
              {/* Name Field */}
              <div>
                <label htmlFor="name" className="block text-sm font-semibold flex items-center gap-2 text-slate-700 mb-2">
                  <span className="text-xl">👤</span> Your Name
                </label>
                <input
                  {...register("name")}
                  defaultValue={user?.displayName || ""}
                  readOnly
                  placeholder="Your Name"
                  className="block w-full rounded-xl border border-slate-200 bg-slate-50 text-slate-500 px-4 py-3 shadow-sm focus:border-amber-500 focus:ring-amber-500 sm:text-sm cursor-not-allowed transition-colors"
                />
              </div>

              {/* Review Field */}
              <div>
                <label htmlFor="review" className="block text-sm font-semibold flex items-center gap-2 text-slate-700 mb-2">
                  <span className="text-xl">✍️</span> Your Review
                </label>
                <textarea
                  {...register("review", { required: true })}
                  placeholder="Tell us what you loved (or what we could improve)..."
                  className="block w-full rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-amber-500 focus:ring-amber-500 sm:text-sm h-36 resize-none transition-colors placeholder:text-slate-400"
                />
                {errors.review && (
                  <p className="mt-2 text-sm text-red-500 font-medium">Please share your thoughts to continue.</p>
                )}
              </div>

              {/* Rating Field */}
              <div>
                <label htmlFor="rating" className="block text-sm font-semibold flex items-center gap-2 text-slate-700 mb-2">
                  <span className="text-xl">⭐</span> Rating
                </label>
                <input
                  {...register("rating", { required: true })}
                  type="number"
                  min="1"
                  max="5"
                  placeholder="Rate out of 5"
                  className="block w-full rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-amber-500 focus:ring-amber-500 sm:text-sm transition-colors placeholder:text-slate-400"
                />
                {errors.rating && (
                  <p className="mt-2 text-sm text-red-500 font-medium">A rating between 1 and 5 is required.</p>
                )}
              </div>

              {/* Submit Button */}
              <div className="pt-4 mt-8 border-t border-slate-100">
                <button
                  type="submit"
                  className="w-full flex justify-center items-center gap-2 py-3.5 px-4 rounded-xl text-base font-semibold text-white bg-slate-900 hover:bg-amber-500 hover:text-slate-900 transition-all duration-300"
                >
                  Submit Review
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Review;
